"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function PrivacyPolicyContent() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para1Ref,
    isVisible: para1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para2Ref,
    isVisible: para2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para3Ref,
    isVisible: para3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para4Ref,
    isVisible: para4Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="w-full min-h-screen py-16 px-4 bg-[#F7DDE2]">
      <div className="mx-auto max-w-[800px] bg-[#F4C9D3] rounded-xl shadow-soft p-16">
        <h1 ref={headingRef} className={`text-4xl font-display font-bold text-foreground-light mb-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} hover:-translate-y-0.5`}>
          Privacy Policy
        </h1>

        <div ref={para1Ref} className={`mb-6 text-foreground-body leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${para1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: para1Visible ? "150ms" : "0ms"
      }}>
          <p>
            We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website or use our services.
          </p>
        </div>

        <div ref={para2Ref} className={`mb-6 text-foreground-body leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${para2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: para2Visible ? "300ms" : "0ms"
      }}>
          <h2 className="text-2xl font-display font-semibold text-foreground-light mb-3">Information We Collect</h2>
          <p>
            We may collect personal information such as your name, email address, phone number, and other contact details when you voluntarily provide them through forms on our website. We also collect non-personal information such as browser type, IP address, and website usage data through cookies and analytics tools.
          </p>
        </div>

        <div ref={para3Ref} className={`mb-6 text-foreground-body leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${para3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: para3Visible ? "450ms" : "0ms"
      }}>
          <h2 className="text-2xl font-display font-semibold text-foreground-light mb-3">How We Use Your Information</h2>
          <p>
            Your personal information is used to provide you with requested services, respond to inquiries, improve our website, and send you relevant updates or promotional materials if you have opted in. We do not sell or share your personal information with third parties except as required by law or to facilitate service delivery.
          </p>
        </div>

        <div ref={para4Ref} className={`text-foreground-body leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${para4Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: para4Visible ? "600ms" : "0ms"
      }}>
          <h2 className="text-2xl font-display font-semibold text-foreground-light mb-3">Your Rights</h2>
          <p className="mb-4">
            You have the right to access, update, or delete your personal information at any time. If you have questions or concerns about our privacy practices, please{" "}
            <Link to="/ContactPagePage" className="text-primary-600 underline decoration-primary-300 decoration-2 underline-offset-2 hover:decoration-primary-600 hover:text-primary-700 transition-all duration-[var(--duration-fast)]">
              contact us
            </Link>.
          </p>
          <p>
            By using our website, you consent to the terms outlined in this Privacy Policy. We may update this policy from time to time, and any changes will be posted on this page with an updated effective date.
          </p>
        </div>
      </div>
    </section>;
}